import React, { useEffect, useState } from 'react';
import { useLocation, useSearchParams } from 'react-router-dom';
import { getPublicStats, getCurrentEvent, getNextEvent } from '../services/api';
import Hero from '../components/marketing/Hero';
import FilmSection from '../components/marketing/FilmSection';
import HowItWorks from '../components/marketing/HowItWorks';
import PoolsSection from '../components/marketing/PoolsSection';
import { ChatSection, RulesSection, BadgesSection } from '../components/marketing/FeatureSections';
import AppWallSection from '../components/marketing/AppWallSection';
import Ticker from '../components/marketing/Ticker';
import DisclaimerSection from '../components/marketing/DisclaimerSection';
import FinalCta from '../components/marketing/FinalCta';
import { scrollToId } from '../components/motion/SmoothScroll';
import '../styles/marketing.css';

/**
 * picknpray.com: the "Fight Night" marketing page (see client/DESIGN.md).
 * Live data: public pool stats, the current (or next) UFC card, and the
 * DemoPicks widget on that card's real fights, which leads the hero (#demo).
 */
function Home() {
  const [params] = useSearchParams();
  const { hash } = useLocation();
  const isTitleShotInvite = params.get('ref') === 'titleshot';
  const [stats, setStats] = useState(null);
  const [featuredEvent, setFeaturedEvent] = useState(null);

  useEffect(() => {
    let cancelled = false;
    Promise.all([
      getPublicStats().catch(() => null),
      getCurrentEvent().catch(() => null),
      getNextEvent().catch(() => null),
    ]).then(([statsRes, currentRes, nextRes]) => {
      if (cancelled) return;
      if (statsRes?.data) setStats(statsRes.data);
      const event = currentRes?.data || nextRes?.data || null;
      if (event) setFeaturedEvent(event);
    });
    return () => { cancelled = true; };
  }, []);

  // /#how, /#pools, /#demo from other pages: scroll once the page has laid out.
  useEffect(() => {
    if (!hash) return undefined;
    const id = hash.slice(1);
    // Re-aim a few times while fonts, live data and posters settle the layout.
    const timers = [80, 450, 1100].map((ms) => setTimeout(() => scrollToId(id, { immediate: true }), ms));
    return () => timers.forEach(clearTimeout);
  }, [hash]);

  return (
    <div className="pnp-home">
      <Hero stats={stats} titleShotInvite={isTitleShotInvite} />
      <FilmSection />
      <HowItWorks />
      <Ticker />
      <PoolsSection stats={stats} />
      <ChatSection />
      <RulesSection />
      <BadgesSection />
      <AppWallSection />
      <DisclaimerSection />
      <FinalCta event={featuredEvent} />
    </div>
  );
}

export default Home;
